module.exports = __webpack_public_path__ + "img/bg_shicai.4a4fb12f.png";